module.exports = __webpack_public_path__ + "static/write2congressAndroid-d104253d1514b7dacd38d13b85a1c324.jpg";